/**
 * Test if IOS
 *
 * @return {boolean}
 */
const isIOS = () => {
  const textSearch = [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod",
  ];
  const stringAnalyze = navigator.userAgent || navigator.platform;
  const matchesPlatform = textSearch.some(e => stringAnalyze.includes(e));

  return matchesPlatform
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
};

/**
 * Test if Android
 *
 * @return {boolean}
 */
const isAndroid = () => {
  return (navigator.userAgent || navigator.platform).includes("Android");
};

export {isIOS, isAndroid};
